function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m312 104h-40l-16 40h40z",
  fill: "#639aff"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m304 240h36.46788a27.53212 27.53212 0 0 1 27.53212 27.53212v4.46788l-32 104h-32l16-104h-80a32 32 0 0 1 -32-32 79.99887 79.99887 0 0 1 1.61634-16h94.38366z",
  fill: "#ffceb6"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m304 240h36.46788a27.53212 27.53212 0 0 1 27.53212 27.53212v4.46788l-32 104h-32l16-104h-80a32 32 0 0 1 -32-32 79.99887 79.99887 0 0 1 1.61634-16h94.38366z",
  fill: "#718799"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m368 223a16.99834 16.99834 0 0 1 -17 17h-55.62012a32.00389 32.00389 0 0 1 -24.98974-12.01l-3.19014-3.99h-57.57988a79.96936 79.96936 0 0 1 4.52978-14.77l25.23-60.55a33.60209 33.60209 0 0 1 64.6201 12.9201v38.3999l24 3 25.10986 3.14014a16.97179 16.97179 0 0 1 14.89014 16.85986z",
  fill: "#ffceb6"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m328 203v37h-32.62012a32.00389 32.00389 0 0 1 -24.98974-12.01l-3.19014-3.99h-57.57988a79.96936 79.96936 0 0 1 4.52978-14.77l25.23-60.55a33.60209 33.60209 0 0 1 64.6201 12.9201v38.3999z",
  fill: "#7dafff"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m24 160h144v144h-144z",
  fill: "#ffc431"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m104 216h-16v-24a8 8 0 0 1 8-8 8 8 0 0 1 8 8z",
  fill: "#ffa100"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m96 344-24-24v-16h64z",
  fill: "#ef5e3b"
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  cx: 96,
  cy: 416,
  fill: "#b6caf0",
  r: 48
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "m96 472a56 56 0 1 1 56-56 56.0629 56.0629 0 0 1 -56 56zm0-96a40 40 0 1 0 40 40 40.04584 40.04584 0 0 0 -40-40z",
  fill: "#718799"
});

var _ref12 = /*#__PURE__*/React.createElement("circle", {
  cx: 440,
  cy: 416,
  fill: "#b6caf0",
  r: 48
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "m440 472a56 56 0 1 1 56-56 56.0629 56.0629 0 0 1 -56 56zm0-96a40 40 0 1 0 40 40 40.04584 40.04584 0 0 0 -40-40z",
  fill: "#718799"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "m376 376 51.02944 51.02944a16.97054 16.97054 0 0 0 12 4.97056 16.97054 16.97054 0 0 0 16.97056-16.97055 16.97054 16.97054 0 0 0 -4.97056-12l-51.02944-51.02945z",
  fill: "#d1e4ff"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "m392 328h72a24 24 0 0 1 24 24v16h-96z",
  fill: "#548aff"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "m456 304v24h-32l-56 112h-160v-48h48l40.23 7.31 47.77 8.69 40-80-16-80h24l32 48z",
  fill: "#4f7ff7"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "m48 248h96a24 24 0 0 1 -24 24h-48a24 24 0 0 1 -24-24z",
  fill: "#ffa100"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "m128 248v-8a32 32 0 0 0 -32-32 32 32 0 0 0 -32 32v8z",
  fill: "#ffb401"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "m112 304h184v24a72 72 0 0 1 -72 72h-96l-48-48z",
  fill: "#548aff"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "m168 272h104a24 24 0 0 1 24 24v8h-128z",
  fill: "#486be0"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "m136 432h-56v-32h32z",
  fill: "#d1e4ff"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "m368 248v-40h32l24 16-8 24z",
  fill: "#548aff"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "m313.54 201.19-19.09-2.38-21.61-43.23 14.32-7.16z",
  fill: "#639aff"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "m320 96v32h-40l-40-24v-24a32.00409 32.00409 0 0 1 32-32 47.97432 47.97432 0 0 1 48 48z",
  fill: "#548aff"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "m320 96v16l-48-24v-16h41.58008a47.72722 47.72722 0 0 1 6.41992 24z",
  fill: "#9ce6ed"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "m352 392-8 16-47.77-8.69 7.77-23.31h32z",
  fill: "#e0edff"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "m352 152h24a16 16 0 0 1 16 16v16a0 0 0 0 1 0 0h-24a16 16 0 0 1 -16-16v-16a0 0 0 0 1 0 0z",
  fill: "#718799"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "m376 184h16v24h-16z",
  fill: "#62798c"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "m424 328v-32l32 8v24z",
  fill: "#7dafff"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "m208 440h-72l-40-40h112z",
  fill: "#e0edff"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "m328 240h-32.62012a39.80132 39.80132 0 0 1 -31.23437-15.0127l-22.39258-27.98925 12.49414-9.9961 22.39258 27.99024a23.87964 23.87964 0 0 0 18.74023 9.00781h32.62012z",
  fill: "#639aff"
});

var SvgDelivering = function SvgDelivering(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "flat",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDelivering, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delivering.b6d9122a.svg";
export { ForwardRef as ReactComponent };